import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["error", "options", "resolver", "specialOptions", "onBlur", "onChange"];
import { List } from 'immutable';
import I18n from 'I18n';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import ReferenceInputEnum from 'customer-data-reference-ui-components/ReferenceInputEnum';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message

import { FormControl } from 'foundations-components/transitional/components/FormControl';
import isEmpty from 'transmute/isEmpty';
import { allowedProps, filterInputProps } from './filterInputProps';
import { useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const getOptions = (options, specialOptions, resolver) => {
  if (resolver) {
    return List.isList(specialOptions) ? specialOptions : List();
  }
  if (List.isList(options) && List.isList(specialOptions)) {
    return specialOptions.concat(options);
  }
  if (isEmpty(options) && List.isList(specialOptions)) {
    return specialOptions;
  }
  return options || List();
};
const formatOption = group => {
  const label = group.get('id') === 'DEFAULT' ? I18n.text('customerDataFiltersUI.customerDataFilters.FilterOperatorEmailSubscriptionInput.defaultSubscriptionTypes') : group.get('label');
  return {
    text: label,
    options: group.getIn(['referencedObject', 'translatedSubscriptionDefinitions']).reduce((options, type) => [/* eslint-disable-next-line hubspot-dev/no-reduce-accumulator-copy */
    ...options, {
      text: type.getIn(['subscriptionDefinition', 'name']),
      value: `${type.getIn(['subscriptionDefinition', 'id'])}`,
      help: type.getIn(['subscriptionDefinition', 'description'])
    }], [])
  };
};
export default function FilterOperatorEmailSubscriptionInput(_ref) {
  let {
      error,
      options,
      resolver,
      specialOptions,
      onBlur,
      onChange
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [isOpen, setIsOpen] = useState(false);
  const isError = error.get('error');
  const errorMessage = error.get('message');
  const onOpenChange = evt => {
    setIsOpen(evt.target.value);
    if (evt.target.value === false && onBlur) {
      onBlur();
    }
  };
  const onChangeLocal = evt => {
    onChange(evt, isOpen);
  };
  return /*#__PURE__*/_jsx(FormControl, {
    "aria-label": I18n.text('customerDataFiltersUI.customerDataFilters.FilterOperatorInput.ariaLabel'),
    error: isError,
    validationMessage: isError ? errorMessage : null,
    children: /*#__PURE__*/_jsx(ReferenceInputEnum, Object.assign({}, filterInputProps(rest, [...allowedProps, 'multi']), {
      onChange: onChangeLocal,
      onOpenChange: onOpenChange,
      optionFormatter: formatOption,
      options: getOptions(options, specialOptions, resolver),
      resolver: resolver
    }))
  });
}